import type { UserVotedNarratives } from '../useNarrativePermission/queryFn';

export const updateVoteCounts = (
  upvotes: number,
  downvotes: number,
  existingVoteType: 0 | 1 | -1,
  voteType: 1 | -1
): { upvotes: number; downvotes: number } => {
  switch (existingVoteType) {
    case 0:
      voteType === 1 ? upvotes++ : downvotes++;
      break;
    case voteType:
      voteType === 1 ? upvotes-- : downvotes--;
      break;
    default:
      upvotes += voteType;
      downvotes -= voteType;
      break;
  }

  return {
    upvotes,
    downvotes,
  };
};

export const updateUserVotedNarratives = (
  userVotedNarratives: UserVotedNarratives,
  existingVoteType: 0 | 1 | -1,
  voteType: 1 | -1,
  narrativeId: string
): UserVotedNarratives => {
  if (existingVoteType === 0) {
    return [...userVotedNarratives, { narrativeId, voteType }];
  }
  const remainingVotes = userVotedNarratives.filter(
    (n) => n.narrativeId !== narrativeId
  );
  if (existingVoteType === voteType) {
    return [...remainingVotes];
  }
  return [...remainingVotes, { narrativeId, voteType }];
};
